export default __webpack_public_path__ + "static/media/arrowUp.0dd93b8a.svg";